import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        padding: "200px 0",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.6",
      }}
    >
      <h1>Política de Privacidad</h1>

      <h2>Qué datos recopila nuestro bot</h2>
      <p>
        El bot de MotoAsesor recopila y procesa los siguientes datos personales
        de los usuarios:
      </p>

      <ul>
        <li>Número de teléfono asociado a la cuenta de WhatsApp.</li>
        <li>Nombre del usuario si está disponible en el perfil de WhatsApp.</li>
        <li>
          Mensajes enviados voluntariamente por el usuario, incluyendo:
          <ul>
            <li>Datos de contacto (si los proporciona).</li>
            <li>
              Información sobre su motocicleta (marca, modelo, año, estado,
              kilometraje).
            </li>
            <li>
              Descripciones de fallas o consultas técnicas relacionadas con su
              moto.
            </li>
            <li>Imágenes o videos enviados de la moto o sus partes.</li>
            <li>
              Respuestas a formularios o preguntas automáticas del bot
              relacionadas con servicios de taller, presupuestos o diagnósticos.
            </li>
          </ul>
        </li>
      </ul>

      <h2>Cómo se usan estos datos</h2>
      <p>Los datos recolectados se utilizan únicamente para:</p>

      <ul>
        <li>
          Analizar el estado de las motocicletas y ofrecer diagnósticos
          preliminares de fallas.
        </li>
        <li>Gestionar presupuestos de reparación y mantenimiento.</li>
        <li>Coordinar turnos y servicios en el taller mecánico.</li>
        <li>
          Brindar información técnica relevante sobre el cuidado de las
          motocicletas.
        </li>
        <li>
          Mejorar la calidad de atención y el servicio brindado a los clientes.
        </li>
      </ul>

      <p>
        Los datos no se comparten con terceros, salvo que sea necesario para
        cumplir con obligaciones legales o para la gestión interna del taller
        (por ejemplo, personal autorizado de MotoAsesor).
      </p>

      <h2>
        Cómo los usuarios pueden solicitar la eliminación o rectificación de sus
        datos
      </h2>
      <p>Los usuarios pueden en cualquier momento solicitar:</p>

      <ul>
        <li>La eliminación de sus datos personales.</li>
        <li>La rectificación o actualización de los mismos.</li>
      </ul>

      <p>
        Para ello, pueden enviar un mensaje por WhatsApp indicando "Eliminar mis
        datos" o "Actualizar mis datos", o contactarnos por correo electrónico
        a:
      </p>

      <p>
        <strong>contacto@motoasesor.com</strong> (o tu correo de contacto real)
      </p>

      <p>
        Procesaremos estas solicitudes en un plazo razonable, de acuerdo con la
        normativa vigente.
      </p>

      <h2>Cómo se protegen los datos</h2>
      <p>
        MotoAsesor implementa medidas de seguridad administrativas y técnicas
        para proteger la información recopilada, incluyendo:
      </p>

      <ul>
        <li>
          Uso de servidores seguros con protocolos HTTPS para la transmisión de
          datos.
        </li>
        <li>
          Restricción de acceso a la información solo al personal autorizado.
        </li>
        <li>
          Monitoreo y mantenimiento continuo de los sistemas de información.
        </li>
        <li>
          Almacenamiento de datos únicamente por el tiempo necesario para
          cumplir con los fines mencionados o según lo requiera la ley.
        </li>
      </ul>

      <p>
        Para cualquier consulta adicional sobre nuestra política de privacidad,
        puede contactarnos en:
      </p>

      <p>
        <strong>info@motoasesor.com.ar</strong>
      </p>
      <p>O mediante WhatsApp al número de atención habitual.</p>
    </div>
  );
};

export default PrivacyPolicy;
